/** @format */

export default {
  bind(el, binding) {
    let timer = null;
    const delay = binding.arg ? Number(binding.arg) : 600;

    // защита от выделения текста
    el.style.userSelect = 'none';
    el.style.webkitUserSelect = 'none';
    el.style.webkitTouchCallout = 'none';
    el.style.touchAction = 'manipulation';

    const start = (e) => {
      // только touch или мышь
      if (e.type === 'mousedown' && e.button !== 0) return;

      if (binding.modifiers.prevent) e.preventDefault();

      timer = setTimeout(() => {
        binding.value(e);
      }, delay);
    };

    const cancel = () => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    };

    el.__longPressHandlers__ = { start, cancel };

    el.addEventListener('touchstart', start, { passive: false });
    el.addEventListener('touchend', cancel);
    el.addEventListener('touchmove', cancel);
    el.addEventListener('mousedown', start);
    el.addEventListener('mouseup', cancel);
    el.addEventListener('mouseleave', cancel);
  },

  unbind(el) {
    const h = el.__longPressHandlers__;
    if (!h) return;

    el.removeEventListener('touchstart', h.start);
    el.removeEventListener('touchend', h.cancel);
    el.removeEventListener('touchmove', h.cancel);
    el.removeEventListener('mousedown', h.start);
    el.removeEventListener('mouseup', h.cancel);
    el.removeEventListener('mouseleave', h.cancel);

    delete el.__longPressHandlers__;
  },
};
